// @flow

import * as React from 'react';

type Props = {
  active: boolean,
  children: React.Node,
};

type State = {
  done: boolean,
};

export default class FirstLoadController extends React.Component<Props, State> {
  state = {
    done: false,
  };

  oldDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (prevState.done || !nextProps.active) return null;
    
    return this.setState({
      done: true,
    });
  }

  componentDidMount() {
    this.oldDerivedStateFromProps(this.props, this.state);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.oldDerivedStateFromProps(this.props, this.state);
    }
  }

  render() {
    if (this.state.done || this.props.active) {
      return this.props.children;
    }

    return null;
  }
}
